import { useEffect, useState } from 'react';

function readLayer() {
    const bp = document.documentElement.dataset.headerBp;
    if (bp === 'phone' || bp === 'tablet' || bp === 'desktop') return bp;
    const width = window.innerWidth;
    return width < 640 ? 'phone' : width < 1024 ? 'tablet' : 'desktop';
}

/**
 * Module box layer for the current viewport. The Appearance preview forces one
 * through `html[data-header-bp]`, whatever width the iframe happens to be.
 * @returns {'desktop'|'tablet'|'phone'}
 */
export default function useChromeLayer() {
    const [layer, setLayer] = useState('desktop');

    useEffect(() => {
        const read = () => setLayer(readLayer());
        read();
        const observer = new MutationObserver(read);
        observer.observe(document.documentElement, {
            attributes: true,
            attributeFilter: ['data-header-bp'],
        });
        window.addEventListener('resize', read);
        return () => {
            observer.disconnect();
            window.removeEventListener('resize', read);
        };
    }, []);

    return layer;
}
